import { WidgetSettings } from '@gsc/types'
import { ActionEventTypes, Event, EventType } from './event'
import { EventContext } from './event-context'

export const defaultEnabledEvents = [EventType.Show, EventType.Close, ...ActionEventTypes]

export class ConfigBase {
  private readonly enabled: boolean

  constructor(config?: any, protected enabledEvents: string[] = defaultEnabledEvents) {
    if (typeof config === 'boolean') {
      this.enabled = config
    } else if (config !== undefined && config !== null) {
      throw new Error(`"${typeof config}" config not implemented`)
    }

    this.track = this.track.bind(this)
  }

  public isEnabled(): boolean {
    return this.enabled !== false
  }

  public isEnabledDefault(): boolean {
    return this.enabled === true
  }

  public isEventEnabled({ type, widget }: Event): boolean {
    return this.enabledEvents.indexOf(type) !== -1 && this.isWidgetEnabled(widget)
  }

  protected isWidgetEnabled(widget: Partial<WidgetSettings>): boolean {
    return this.isEnabledDefault()
  }

  protected getQueue(): (e: Event) => void {
    throw new Error('not implemented')
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  protected async finalize(ctx: EventContext) {}

  public async track(events: Event[], ctx: EventContext) {
    events = events.filter(e => this.isEventEnabled(e))
    if (events.length === 0) {
      return
    }

    const queue = this.getQueue()
    if (queue) {
      events.forEach((e, ctx) => queue(e))
    }

    await this.finalize(ctx)
  }
}
